import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Smartphone } from "lucide-react";

export function SmsAlertsCard({ customerId }) {
  const [cfg, setCfg] = useState(null);
  const [phone, setPhone] = useState("");
  const [busy, setBusy] = useState(false);
  const url = customerId ? `/customers/${customerId}/sms-alerts` : "/auth/me/sms-alerts";
  useEffect(() => { api.get("/auth/me/sms-alerts").then(({ data }) => { setCfg(data); setPhone(data.phone || ""); }).catch(() => {}); }, []);
  const save = async (enabled) => {
    setBusy(true);
    try { const { data } = await api.put(url, { enabled, phone: phone || null }); setCfg({ ...cfg, ...data }); toast.success(enabled ? "Text alerts on" : "Text alerts off"); }
    catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  if (!cfg) return null;
  return (
    <Card className="p-6 border-t-4 border-t-sky-500" data-testid="sms-alerts-card">
      <div className="flex items-center justify-between gap-2">
        <h2 className="font-semibold flex items-center gap-2"><Smartphone className="h-5 w-5 text-sky-700" />Expiration text alerts</h2>
        <Switch checked={!!cfg.enabled} onCheckedChange={(v) => save(v)} disabled={busy || (!cfg.enabled && !phone)} data-testid="sms-alerts-toggle" />
      </div>
      <p className="text-sm text-slate-600 mt-1">One short text when any driver or vehicle document hits the {cfg.days}-day mark — CDL, med card, registration, inspection, filings. Emails keep coming as usual.</p>
      <div className="flex items-end gap-2 mt-3">
        <div className="flex-1"><Label className="text-xs">Mobile number</Label><Input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="(336) 555-0123" data-testid="sms-alerts-phone" /></div>
        <Button variant="outline" onClick={() => save(cfg.enabled || true)} disabled={busy || !phone} data-testid="sms-alerts-save">Save & enable</Button>
      </div>
      {!cfg.sms_available && <p className="text-[11px] text-amber-700 mt-2">Texting isn't active yet — your setting is saved and texts start as soon as messaging is switched on.</p>}
      <p className="text-[11px] text-slate-500 mt-2">Msg &amp; data rates may apply. Reply STOP to any text to opt out.</p>
    </Card>
  );
}
